const config = {
  googleClientID : process.env.REACT_APP_GOOGLE_CLIENT_ID,
};

export default config;
